import { render, staticRenderFns } from "./AddMappingDomain.vue?vue&type=template&id=2f13f349&scoped=true"
import script from "./AddMappingDomain.vue?vue&type=script&lang=js"
export * from "./AddMappingDomain.vue?vue&type=script&lang=js"
import style0 from "./AddMappingDomain.vue?vue&type=style&index=0&id=2f13f349&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f13f349",
  null
  
)

export default component.exports